import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'ellipsis',
})
export class EllipsisPipe implements PipeTransform {
  transform(value: string | undefined | null, limit = 30): string {
    if (!value) {
      return '';
    }
    if (value.length > limit) {
      return value.substring(0, limit).concat('...');
    }
    return value;
  }
}
